import { useEffect, useState, RefObject } from 'react';

const useResizeObserver = (ref: RefObject<HTMLElement>, timer: number = 150) => {
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    let timeoutId: any;

    const observer = new ResizeObserver(entries => {
      for (const entry of entries) {
        const { width, height } = entry.contentRect;

        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
          setDimensions({ width, height });
        }, timer);
      }
    });

    observer.observe(element);

    return () => {
      observer.disconnect();
      clearTimeout(timeoutId);
    };
  }, [ref, timer]);

  return dimensions;
};

export default useResizeObserver;
